<template>
  <div class="p-5">
    <b-row class="mt-4 pb-4">
      <b-col align-self="center">
        <h4>GAV Spezifische Feiertage</h4>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <b-row>
      <b-col cols="2">
        <label class="mx-3 mt-4 defaultLabel"> Jahr </label>
        <v-select
          :disabled="yearSelection.length <= 1"
          :items="yearSelection"
          :value="selectedYear"
          @change="setDateRangetoYear"
        />
      </b-col>
    </b-row>

    <!-- Search Section -->
    <div class="mt-5">
      <v-btn
        v-if="canUserEdit"
        class="float-right"
        color="success"
        flat
        title="Neuen Feiertag erfassen"
        @click="createNew"
      >
        <i class="fas fa-plus mr-3" /> Erfassen
      </v-btn>
      <b-row>
        <b-col cols="4">
          <v-text-field
            id="searchInput"
            v-model="searchTerm"
            append-icon="fas fa-search"
            class="search--input"
            label="GAV Feiertag suchen..."
          />
        </b-col>
        <b-col cols="1">
          <label class="mt-4 defaultLabel float-right"> Von </label>
        </b-col>
        <b-col cols="2">
          <u-date-picker
            v-model="searchFrom"
            :max="maxDate"
            :min="minDate"
            label=""
            @change="getCalenders"
          />
        </b-col>
        <b-col cols="1">
          <label class="mt-4 defaultLabel float-right"> Bis </label>
        </b-col>
        <b-col cols="2">
          <u-date-picker
            v-model="searchTo"
            :max="maxDate"
            :min="minDate"
            label=""
            @change="getCalenders"
          />
        </b-col>
        <b-col>
          <v-autocomplete
            v-model="selectedCityFilter"
            :items="cityFilterOptions"
            item-text="text"
            item-value="id"
            label="Filter nach Ort"
            clearable
          />
        </b-col>
      </b-row>
      <div
        class="mt-5 ml-3"
        style="width: 100%"
      >
        <b-select
          v-model="resultsPerPage"
          class="custom-select ml-1"
          style="width: 62px; height: 31px; font-size: 12px"
        >
          <option :value="10">
            10
          </option>
          <option :value="25">
            25
          </option>
          <option :value="50">
            50
          </option>
          <option :value="100">
            100
          </option>
        </b-select>
        <label
          style="font-weight: bold; margin-left: 3px"
        >Anzahl Resultate</label>
        <b-pagination
          v-model="currentPage"
          :per-page="resultsPerPage"
          :total-rows="totalNumberOfResults"
          class="float-right mr-3"
          first-text="<<"
          last-text=">>"
          next-text="Nächste"
          prev-text="Vorherige"
        />
      </div>
    </div>
    <!-- END Search Section -->

    <!-- Table Section -->
    <div class="ml-4 mr-4">
      <v-flex
        v-if="isLoading"
        justify-center
      >
        <u-loader />
      </v-flex>
      <table
        v-else
        class="w-100 calenderOverview ml-2 mt-4"
      >
        <thead>
          <tr>
            <th>Datum</th>
            <th>Bezeichnung</th>
            <th>Feiertagstyp</th>
            <th>Gültigkeitsbereich</th>
            <th>Geprüft</th>
            <th>GAV-Feiertagstyp</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="calendar in resourceCalendars"
            :key="calendar.id"
          >
            <td class="custom-td">
              {{ calendar.date | formatDate }}
              <br>
              {{ calendar.date | formatDay }}
            </td>
            <td class="custom-td">
              {{ calendar.holidayDescription }}
            </td>
            <td class="custom-td">
              {{
                publicHolidayTypes
                  | validateAndGetValue(calendar.publicHolidayType)
              }}
            </td>
            <td class="custom-td">
              <b-button
                v-b-toggle="calendar.id.toString()"
                class="m-1"
                @click="expandPanel(calendar.id)"
              >
                <i
                  v-if="calendar.isCollapsed"
                  class="fas fa-eye-slash mr-2"
                />
                <i
                  v-else
                  class="fas fa-eye mr-2"
                />
                {{ calendar.isCollapsed ? "Ausblenden" : "Einblenden" }}
              </b-button>
              <b-collapse
                :id="calendar.id.toString()"
                v-model="calendar.isCollapsed"
              >
                <b-card>
                  <v-flex
                    v-if="isLoadingTreeView[calendar.id]"
                    justify-center
                  >
                    <u-loader />
                  </v-flex>

                  <div
                    v-if="
                      calendar.isCollapsed && !isLoadingTreeView[calendar.id]
                    "
                  >
                    <div id="tree-overlay" />
                    <v-treeview
                      v-model="selectedLocations[calendar.id]"
                      :items="locationTree[calendar.id]"
                      :open-all="true"
                      activatable
                      class="mt-2"
                    >
                      <template v-slot:prepend="{ item }">
                        <i :class="getIcon(item)" />
                      </template>
                    </v-treeview>
                  </div>
                </b-card>
              </b-collapse>
            </td>
            <td>
              <v-checkbox
                v-model="calendar.validated"
                :disabled="true"
              />
            </td>
            <td
              :style="{
                background:
                  calendar.publicHolidayType !== calendar.gavPublicHolidayType
                    ? 'lightgray'
                    : 'white',
              }"
              class="custom-td"
            >
              {{
                publicHolidayTypes
                  | validateAndGetValue(calendar.gavPublicHolidayType)
              }}
            </td>
            <td class="custom-td">
              <div v-if="calendar.configurationId">
                <v-btn
                  v-if="canUserEdit"
                  class="pt-0"
                  color="#007bff"
                  dark
                  fab
                  small
                  title="Bearbeiten"
                  @click="
                    resourceCalendarToEdit = calendar;
                    showModal('calendarEdit');
                  "
                >
                  <i class="fas fa-edit" />
                </v-btn>
                <v-btn
                  v-if="canUserEdit"
                  color="#e72b37"
                  dark
                  fab
                  small
                  title="Löschen"
                  @click="
                    resourceCalendarToDeleteId = calendar.id;
                    showModal('confirmDeleteResourceCalendar');
                  "
                >
                  <i class="fas fa-trash" />
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  v-if="canUserEdit"
                  class="pt-0"
                  color="#007bff"
                  dark
                  fab
                  small
                  title="Feiertagstyp bearbeiten"
                  @click="
                    showModal('overwriteGavPublicHolidayType');
                    resourceCalendarToEdit = calendar;
                    selectedGavHolidayType = gavHolidayTypesOptions.find(
                      (x) =>
                        x.value == calendar.gavPublicHolidayType.toString(),
                    );
                  "
                >
                  <i class="fas fa-edit" />
                </v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- END Table Section -->

    <!-- --- Modal Section ---- -->
    <!-- Create new Calender -->
    <v-dialog
      v-model="calendarCreateOpen"
      max-width="900"
    >
      <v-card>
        <v-card-title>
          <h5>GAV-Feiertag erstellen</h5>
        </v-card-title>
        <gav-holidays-create
          class="p-3"
          :public-holiday-types="gavHolidayTypesOptions"
          :localised-options="locationOptions"
          @canceled="hideModal('calendarCreate')"
          @saved="handleResourceCalendarSaved"
        />
      </v-card>
    </v-dialog>
    <!-- Edit existing Calender  -->
    <v-dialog
      v-model="calendarEditOpen"
      max-width="900"
    >
      <v-card>
        <v-card-title>
          <h5>GAV-Feiertag bearbeiten</h5>
        </v-card-title>
        <gav-holidays-edit
          class="p-3"
          :resource-calendar-to-edit="resourceCalendarToEdit"
          :public-holiday-types="gavHolidayTypesOptions"
          :localised-options="locationOptions"
          @canceled="handleResourceCalendarSaved"
          @saved="handleResourceCalendarSaved"
        />
      </v-card>
    </v-dialog>
    <!-- Confirm Delete Calender    -->
    <v-dialog
      v-model="confirmDeleteResourceCalendarOpen"
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title>
          <h5>GAV-Feiertag löschen</h5>
        </v-card-title>
        <div class="d-block mb-4">
          Sind Sie sicher, dass Sie diesen GAV-Feiertag löschen möchten?
        </div>
        <div class="d-flex">
          <b-button
            v-if="canUserEdit"
            variant="success"
            @click="deleteResourceCalendar()"
          >
            Ok
          </b-button>
          <b-button
            v-if="canUserEdit"
            class="ml-2"
            variant="danger"
            @click="hideModal('confirmDeleteResourceCalendar')"
          >
            Abbrechen
          </b-button>
        </div>
      </v-card>
    </v-dialog>
    <!-- Overwrite GavPublicHolidayType -->
    <v-dialog
      v-model="overwriteGavPublicHolidayTypeOpen"
      max-width="500"
    >
      <v-card class="pa-4">
        <v-card-title>
          <h5>Feiertagstyp für diesen GAV bearbeiten</h5>
        </v-card-title>
        <div class="d-block mb-4">
          Der gewählte Feiertag wird in diesem GAV folgende Gültigkeit erhalten
        </div>
        <v-select
          :disabled="!canUserEdit"
          :items="gavHolidayTypesOptions"
          :value="selectedGavHolidayType"
          item-text="text"
          item-value="value"
          return-object
          @change="(x) => (selectedGavHolidayType = x)"
        />
        <div class="d-flex mt-4">
          <b-button
            v-if="canUserEdit"
            variant="success"
            @click="saveGavPublicHolidayType()"
          >
            Speichern
          </b-button>
          <b-button
            v-if="canUserEdit"
            class="ml-2"
            variant="danger"
            @click="hideModal('overwriteGavPublicHolidayType')"
          >
            Abbrechen
          </b-button>
        </div>
      </v-card>
    </v-dialog>
    <!-- ---End Modal Section--- -->
  </div>
</template>
<script>
import {
  DeleteRessourceCalendar,
  GetPublicholidaytype,
  GetCalendersWithConfiguration,
  GetSelectedLocationTree,
  GetPublicHolidayYears,
  SaveConfigurationPublicHolidayType,
} from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";
import { ValidateTreeView } from "@/helpers/TreeViewHelperResourceCalendar";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import GavHolidaysCreate from "@/components/minimum.wage/pages/Holidays/Capture/GavHolidaysCreate.vue";
import GavHolidaysEdit from "@/components/minimum.wage/pages/Holidays/Capture/GavHolidaysEdit.vue";
import UDatePicker from "@/components/common/UDatePicker.vue";
import { GetCitiesVNext } from "@/services/contract.edition.cantons.service.js";

export default {
  components: {
    UDatePicker,
    GavHolidaysEdit,
    GavHolidaysCreate,
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day < 10 ? "0" : ""}${day}.${
        month < 10 ? "0" : ""
      }${month}.${year}`;
    },
    formatDay: function (value) {
      if (!value) return "";
      const wochentage = [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
      ];
      const date = new Date(value);
      const wochentagIndex = date.getDay();
      const wochentag = wochentage[wochentagIndex];
      return wochentag;
    },
    validateAndGetValue: function (inputObj, key) {
      if (
        !inputObj ||
        typeof inputObj !== "object" ||
        typeof key === "undefined"
      ) {
        return ""; // Wenn die Eingabe ungültig ist, gib einen leeren String zurück
      }

      // Prüfe, ob der Schlüssel im Objekt vorhanden ist
      if (key in inputObj) {
        return inputObj[key];
      } else {
        return ""; // Wenn der Schlüssel nicht im Objekt vorhanden ist, gib einen leeren String zurück
      }
    },
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      isLoading: false,
      errorObject: null,
      searchTerm: "",
      resourceCalendars: [],
      cityFilterOptions: [],
      selectedCityFilter: 0,
      locationTree: {},
      totalNumberOfResults: 0,
      holidaysInWorkingDays: 0,
      currentPage: 1,
      resultsPerPage: 25,
      sortOrder: 0,
      sortedProperty: "",
      selectedLocations: {},
      resourceCalendarToDeleteId: 0,
      resourceCalendarToEdit: null,
      selectedGavHolidayType: null,
      publicHolidayTypes: "",
      gavHolidayTypesOptions: [],
      expandedPanels: [],
      isLoadingTreeView: {},
      isLoadingImport: false,
      calendarCreateOpen: false,
      calendarEditOpen: false,
      confirmDeleteResourceCalendarOpen: false,
      overwriteGavPublicHolidayTypeOpen: false,
      searchFrom: new Date().toISOString().substr(0, 10),
      searchTo: new Date().toISOString().substr(0, 10),
      yearSelection: [new Date().getFullYear()],
      selectedYear: null,
      maxDate: undefined,
      minDate: undefined,
    };
  },
    computed: {
    locationOptions() {
      let locationsOfEdition =
        this.$store.state.mindestLohnKonfiguration.ValidEditionLocations;

      let citiesCopy = JSON.parse(
        JSON.stringify(this.$store.state.mindestLohnKonfiguration.Cities),
      );
      let topLevel = [
        {
          name: "CH",
          path: "CH",
          children: [],
          shutoff: false,
        },
      ];
      const cantonIdMap = new Map();
      for (const item of citiesCopy) {
        if (!cantonIdMap.has(item.cantonId)) {
          cantonIdMap.set(item.cantonId, true);
          if (locationsOfEdition.some((x) => x.cantonId == item.cantonId)) {
            topLevel[0].children.push({
              id: item.cantonId,
              name: `${item.canton} (${item.cantonCode})`,
              path: `CH/${item.cantonCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      const districtCodeMap = new Map();
      for (const item of citiesCopy) {
        if (!districtCodeMap.has(item.districtCode)) {
          districtCodeMap.set(item.districtCode, true);
          let cantonOfDistrict = topLevel[0].children.find(
            (x) => x.path === `CH/${item.cantonCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId && x.districtId == item.districtId,
            )
          ) {
            cantonOfDistrict.children.push({
              id: item.districtId,
              name: item.district,
              districtCode: item.districtCode,
              path: `CH/${item.cantonCode}/${item.districtCode}`,
              children: [],
              shutoff: false,
            });
          }
        }
      }

      citiesCopy.map((item) => {
        let cantonOfCity = topLevel[0].children.find(
          (x) => x.path === `CH/${item.cantonCode}`,
        );
        if (cantonOfCity) {
          let districtOfCity = cantonOfCity.children.find(
            (x) => x.path === `CH/${item.cantonCode}/${item.districtCode}`,
          );
          if (
            locationsOfEdition.some(
              (x) =>
                x.cantonId == item.cantonId &&
                x.districtId == item.districtId &&
                x.cityId == item.cityId,
            )
          ) {
            item.name = `${item.plz} ${item.city}`;
            item.id = item.cityId;
            item.path = `CH/${item.cantonCode}/${item.districtCode}/${
              item.onrp
            }`;
            item.shutoff = false;
            districtOfCity.children.push(item);
          }
        }
      });

      return topLevel;
    },
  },
  watch: {
    searchTerm() {
      this.getCalenders();
    },
    currentPage() {
      this.getCalenders();
    },
    resultsPerPage() {
      this.currentPage = 1;
      this.getCalenders();
    },
    selectedCityFilter() {
      this.getCalenders();
    },
    "$store.state.mindestLohnKonfiguration.Configuration": function () {
      this.errorObject = null;
      this.getPossibleYears();
      if (this.yearSelection && this.yearSelection.length > 0) {
        this.selectedYear = this.yearSelection
          ? this.yearSelection.find((x) => x == new Date().getFullYear())
          : this.yearSelection[0];
        this.setDateRangetoYear(this.selectedYear);
      }
    },
  },
  created() {
    this.isLoading = true;
    this.loadPublicholidayTypes();
    this.getPossibleYears();
    if (this.yearSelection && this.yearSelection.length > 0) {
      this.selectedYear = this.yearSelection
        ? this.yearSelection.find((x) => x == new Date().getFullYear())
        : this.yearSelection[0];
      this.setDateRangetoYear(this.selectedYear);
    }
  },
  methods: {
    getIcon(node) {
      if (node.selected) {
        return "fas fa-check-square checkbox-right";
      } else {
        return "fas fa-minus-square checkbox-minus";
      }
    },
    getCalenders() {
      this.isLoading = true;
      GetCalendersWithConfiguration(
        this.resultsPerPage,
        this.currentPage,
        this.searchTerm,
        this.sortedProperty,
        this.sortOrder,
        this.editionId,
        this.selectedCityFilter,
        this.searchFrom,
        this.searchTo,
        (response) => {
          this.resourceCalendars = response.ressourceCalendars;
          this.totalNumberOfResults = response.numberOfItems;
          this.holidaysInWorkingDays = response.holidaysInWorkingDays;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    expandPanel(calenderId) {
      if (!this.expandedPanels.some((id) => id === calenderId)) {
        this.$nextTick(() => {
          this.$set(this.selectedLocations, calenderId, []);
          this.$set(this.locationTree, calenderId, []);
          this.$set(this.isLoadingTreeView, calenderId, true);
          this.loadLocationTreeOfCalendar(calenderId);
        });

        this.expandedPanels.push(calenderId);
      }
    },
    loadCities() {
      GetCitiesVNext(
        this.contractId,
        this.versionId,
        this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
        (response) => {
          this.cityFilterOptions = response.map((x) => {
            return {
              id: x.cityId,
              text: x.cityValue,
              path: x.path,
            };
          });
          this.getCalenders();
        },
        (error) => {
          this.PlzErrorObject = error;
        },
      );
    },
    loadPublicholidayTypes() {
      GetPublicholidaytype(
        (response) => {
          this.publicHolidayTypes = response;
          this.gavHolidayTypesOptions = Object.keys(response).map((x) => {
            return {
              text: response[x],
              value: Number(x),
            };
          });
          this.loadCities();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadLocationTreeOfCalendar(calendarId) {
      GetSelectedLocationTree(
        calendarId,
        (response) => {
          GetCitiesVNext(
            this.contractId,
            this.versionId,
            this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
            (cantonResult) => {
              let validCities = cantonResult;
              const validatedTreeView = ValidateTreeView(
                response,
                validCities,
                false,
              );
              this.locationTree[calendarId] = validatedTreeView.treeItems;
              this.selectedLocations[calendarId] =
                validatedTreeView.selectedItems;

              this.$set(this.isLoadingTreeView, calendarId, false);
            },
            (error) => {
              this.errorObject = error;
            },
          );
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    saveGavPublicHolidayType() {
      let configurationHoliday = {
        id: 0,
        ressourceCalendarId: this.resourceCalendarToEdit.id,
        configurationId:
          this.$store.state.mindestLohnKonfiguration.Configuration.id,
        publicHolidayType: this.selectedGavHolidayType.value,
      };

      SaveConfigurationPublicHolidayType(
        configurationHoliday,
        this.resourceCalendarToEdit.id,
        () => {
          this.hideModal("overwriteGavPublicHolidayType");
          this.resourceCalendarToEdit.gavPublicHolidayType =
            configurationHoliday.publicHolidayType;
          this.selectedGavHolidayType = null;
        },
        (error) => {
          this.hideModal("overwriteGavPublicHolidayType");
          this.errorObject = error;
          this.selectedGavHolidayType = null;
        },
      );
    },
    setDateRangetoYear(year) {
      this.searchFrom = new Date(year, 0, 2).toISOString().substr(0, 10);
      this.searchTo = new Date(year, 11, 32).toISOString().substr(0, 10);
      this.minDate = this.searchFrom;
      this.maxDate = this.searchTo;
      this.getCalenders();
    },
    getPossibleYears() {
      let configurationId =
        this.$store.state.mindestLohnKonfiguration.Configuration.id;
      if (configurationId && configurationId != undefined) {
        GetPublicHolidayYears(
          configurationId,
          (response) => {
            this.yearSelection = response;
          },
          (error) => {
            this.errorObject = error;
          },
        );
      }
    },
    handleResourceCalendarSaved() {
      this.locationTree = {};
      this.selectedLocations = {};
      this.isLoadingTreeView = {};
      this.expandedPanels = [];
      this.resourceCalendars = [];
      this.getCalenders();
      this.hideModal("calendarCreate");
      this.hideModal("calendarEdit");
    },
    createNew() {
      this.showModal("calendarCreate");
    },
    deleteResourceCalendar() {
      DeleteRessourceCalendar(
        this.resourceCalendarToDeleteId,
        () => {
          this.hideModal("confirmDeleteResourceCalendar");
          this.handleResourceCalendarSaved();
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    hideModal(modalId) {
      const openStateKey = `${modalId}Open`;
      if (this.hasOwnProperty(openStateKey)) {
        this[openStateKey] = false;
      }
    },
    showModal(modalId) {
      const openStateKey = `${modalId}Open`;
      if (this.hasOwnProperty(openStateKey)) {
        this[openStateKey] = true;
      }
    },
  },
};
</script>
<style scoped>
.calendarTitle {
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  border-top: 2px solid rgb(235, 235, 235);
}

.custom-td {
  vertical-align: top;
}

.calenderOverview {
  font-size: small;
  table-layout: fixed;
}

.calenderOverview thead th:nth-child(1) {
  width: 7%;
}

.calenderOverview thead th:nth-child(2) {
  width: 20%;
}

.calenderOverview thead th:nth-child(3) {
  width: 10%;
}

.calenderOverview thead th:nth-child(4) {
  width: 30%;
}

.calenderOverview thead th:nth-child(5) {
  width: 10%;
}

.calenderOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.calenderOverview td,
.calenderOverview th {
  padding: 8px 4px;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #e72b37;
  border-color: red;
}

/deep/ .page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}

.custom-select.filled-input {
  border-bottom-color: red;
  background-color: #ededed;
  font-weight: bold;
  color: #333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #aaa;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus {
  outline: none;
  border-bottom: 2px solid #333;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für den Pfeil */

.custom-select:after {
  content: "";

  position: absolute;

  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  margin-top: -4px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus:after {
  margin-top: -2px;
  border-top: 5px solid #fdd;
  transform: rotate(180deg);
}

.checkbox-right {
  color: #e72b37;
  font-size: 1.73em;
}

.checkbox-minus {
  color: rgba(0, 0, 0, 0.54);
  font-size: 1.73em;
}

#tree-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  opacity: 0.5;
  background-color: white;
}
</style>
